<template>
  <el-dialog
    class="task-config-modal"
    :visible.sync="taskFormVisible"
    :close-on-click-modal="true"
    @close="onResetForm"
    :title="(isNewTask ? 'Create task' : 'Update task')">

    <TaskConfig
      v-if="( isNewTask || taskId ) && goalId"
      :is-new-task="isNewTask"
      :goal-id="goalId"
      :member-id="memberId"
      :task-id="taskId"
      @done="onGoalConfigDone"
    />

  </el-dialog>
</template>

<script>
import TaskConfig from '@/components/Config/Task/TaskConfig'

export default {
  data: () => ({
    goalId: null,
    memberId: null,
    taskId: null,

    isNewTask: false,
    taskFormVisible: false,
  }),
  computed: {
  },
  methods: {
    showNewModal({ goalId }) {
      console.log("showNewModal", goalId);

      this.goalId = goalId || null; /* optional */
      this.memberId = this.$models.user.defaultUserId;
      this.taskId = null;

      this.isNewTask = true;
      this.taskFormVisible = true;
    },

    showUpdateModal({ goalId, memberId, taskId }) {
      console.log("showUpdateModal", goalId, memberId);
      this.goalId = goalId;
      this.memberId = memberId;
      this.taskId = taskId;

      this.isNewTask = false;
      this.taskFormVisible = true;
    },

    onResetForm() {
      console.log("onResetForm");
      this.isNewTask = false;
      this.goalId = null;
      this.taskId = null;
      this.memberId = null;
      this.taskFormVisible = false;
    },

    onGoalConfigDone() {
      this.onResetForm();
      // this.taskFormVisible = false;
    }
  },
  components: {
    TaskConfig,
  }
}
</script>

<style>
.task-config-modal .el-dialog {
  min-width: 600px;
  max-width: 800px;
}
</style>
